<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">{{ pageTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>


    <v-row v-if="this.nurseryLinks">
      <v-spacer />
      <v-col cols="12" md="11">

        <v-data-table :headers="headers" :items="nurseryLinks.links" sort-by="linkText" must-sort
          class="elevation-1  table-striped" hide-default-footer disable-pagination calculate-widths dense
          :search="search">

          <template v-slot:item="{ item }">
            <tr>
              <td>
                <b><a :href="item.link">{{ item.linkText }}</a></b>
              </td>
              <td>
                <v-icon v-if="item.isNew" large color="red"> mdi-new-box </v-icon>
                {{ item.linkDescription }}
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-col>
      <v-spacer />

    </v-row>


  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  name: "Nurseries",
  computed: {
    pageTitle() {
      return this.$vuetify.breakpoint.smAndDown ? "Nurseries" : "The European Palm Society - Nursery Listings";
    }
  },
  methods: {
    async getNurseryData() {

      const nurseryLinksRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser());
      const result = await serverFunctions.getRawPostResponse("/getNurseryLinks", nurseryLinksRequest);
      this.nurseryLinks = result[0];
    },
  },
  data: () => ({
    nurseryLinks: null,
    headers: [
      {
        text: "Link",
        align: "start",
        value: "linkText",
      },
      {
        text: "Description",
        align: "start",
        value: "linkDescription",
      }],
    search: null,
  }),
  beforeMount() {
    this.getNurseryData();
    userFunctions.updateLastViewed('nurseries');
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}

.card-row-header {
  background-color: rgb(213, 230, 213) !important;
  color: #005050
}

.v-data-table .v-data-table__wrapper table tbody tr:nth-of-type(odd) {
  background-color: rgb(240, 246, 240) !important;
  /* color: #005050 */
}

.v-data-table .v-data-table__wrapper table tbody tr:nth-of-type(even) {
  color: #005050
}
</style>
